import {
  DELETE_ADDRESS_REQUEST,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILURE,
  GET_ALL_ADDRESS_REQUEST,
  GET_ALL_ADDRESS_SUCCESS,
  GET_ALL_ADDRESS_FAILURE,
} from "./ActionType";
import { LOGOUT } from "../../Auth/ActionTypes";

const initialState = {
  loading: false,
  error: null,
  address: [],
  message: "",
  success: false,
};

const addressReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ADDRESS_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case DELETE_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case GET_ALL_ADDRESS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_ALL_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        address: action.payload,
      };
    case GET_ALL_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Clear saved addresses from state on sign-out.
    case LOGOUT:
      return { loading: false, error: null, address: [], message: "", success: false };
    default:
      return state;
  }
};

export default addressReducer;
